import Vue from 'vue/dist/vue.js'
import MainLayout from "./layouts/Main.vue";

Vue.component('money', {
  props: ['price'],
  computed: {
    formatted() {
      // $10 = 1000 so need / 100 before display
      //return parseFloat(this.price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      //return parseFloat(this.price / 100).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return parseFloat(this.price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  },
  template: '<span class="money"><span>HK$</span>{{formatted}}</span>'
})
Vue.component('date', {
  props: ['value', 'format'],
  computed: {
    formatted() {
      return moment(this.value).format(this.format || "YYYY/MM/DD HH:mm");
    }
  },
  template: '<span class="date">{{formatted}}</span>'
})
new Vue(MainLayout).$mount('#app');